import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { GlobalDataService } from "../../../shared-services/global-data.service";
import * as L from 'leaflet';
import { SiteEntityService } from "./site-entity.service";
import { SiteDto } from "../../../dtos/siteDto";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ScreensService } from "../../../theme/screens/screens.service";
import { pipe } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { HotSpot } from '../../../dtos/hotSpot';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { stringify } from 'querystring';
import { PanoramaImages } from '../../../dtos/panoramaImages';

@Component({
    selector: 'app-site-entity',
    templateUrl: './site-entity.component.html',
    styleUrls: ['./site-entity.component.scss']
})
export class SiteEntityComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    @Input()
    site: any;

    @Input()
    screenNumber: any = 1;

    @Input()
    hiddenButtons: any = {};

    selectedMonument: any = undefined;

    @Output()
    siteChanged = new EventEmitter();

    @Output()
    selectedMonumentChanged = new EventEmitter();

    @Output()
    selectedPanoramaChanged = new EventEmitter();

    public languages: any[];
    selectedPanorama: PanoramaImages;
    flowLoading: boolean = false;
    modalParams = {
        edit: false,
        blob: "",
        base64: ""
    }
    private map: any;
    private marker: any;
    @ViewChild('modalPanoramic')
    private modalPanoramicRef: TemplateRef<any>;

    constructor(public globalData: GlobalDataService, private siteEntityService: SiteEntityService,
                private screenService: ScreensService, private modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.languages = this.globalData.globalData.languages;
        this.site.panoramaImages = this.mutateWithNamePanoramaImages(this.site.panoramaImages);
        this.selectedPanorama = this.site.panoramaImages[0];
        this.selectedPanoramaChanged.emit(this.selectedPanorama);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.site && changes.site.previousValue && changes.site.currentValue) {
            this.updateMarker(changes.site.currentValue);
        }
    }

    ngAfterViewInit(): void {
        this.map = L.map('map-' + this.screenNumber).setView([this.site.latitude, this.site.longitude], 13);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        this.marker = L.marker([this.site.latitude, this.site.longitude], {draggable: true}).addTo(this.map);
        this.marker.on('dragend', (event) => {
            let position = this.marker.getLatLng();
            this.site.latitude = position.lat;
            this.site.longitude = position.lng;
            this.siteChanged.emit(this.site);
        });
    }

    ngOnDestroy(): void {
        this.map.off();
        this.map.remove();
        this.map = null;
    }

    changeLatLng() {
        this.updateMarker(this.site);
        this.siteChanged.emit(this.site);
    }

    changePanoramaOfMonument($event) {
        if ($event.delete) {
            const indexToDelete = this.selectedPanorama.panoramaHotSpots.findIndex((el) => el.id === $event.id);
            this.selectedPanorama.panoramaHotSpots.splice(indexToDelete, 1);
            this.selectedMonument = null;
        }
        this.selectedMonumentChanged.emit($event);
        this.selectedPanorama.panoramaHotSpots = [...this.selectedPanorama.panoramaHotSpots];
    }

    changePanoramaImage() {
        this.selectedMonument = null;
        this.selectedPanoramaChanged.emit(this.selectedPanorama);
    }

    saveSite(goToNext?) {
        this.flowLoading = true;
        //delete the auto generated ids of imported hotspots assuming that it will never be greater than 100.000
        this.site.panoramaImages.forEach((panoramaImage) => {
            if (panoramaImage.id > 100000) {
                panoramaImage.id = null;
            }
            panoramaImage.panoramaHotSpots.forEach((panoramaHotspot) => {
                if (panoramaHotspot.id > 100000) {
                    panoramaHotspot.id = null;
                }
            })
        })
        this.siteEntityService.saveToBackend(this.site)
            .subscribe((value: any) => {
                this.flowLoading = false;
                let sites = this.screenService.sites.getValue();
                let foundSite = sites.find(el => el.id === value.id);
                if (!foundSite) {
                    sites.push(this.site);
                }
                this.site = foundSite = Object.assign({}, value);
                this.site.panoramaImages = [...this.mutateWithNamePanoramaImages(value.panoramaImages)];
                this.screenService.sites.next(sites);
                this.selectedMonument = null;
                this.selectedPanorama = this.site.panoramaImages[0];
                this.selectedPanoramaChanged.emit(this.selectedPanorama);
            })
    }

    createSite() {
        this.site = new SiteDto();
        this.site.latitude = 39.113966;
        this.site.longitude = 25.074568;
        this.languages.forEach((language) => {
                this.site.siteTranslations.push({
                    id: null,
                    siteId: null,
                    language: language,
                    name: '',
                    shortDescription: '',
                    description: '',
                    century: '',
                    audioPath: ''
                })
            }
        );
        this.siteChanged.emit(this.site);
    }

    deleteSite() {
        Swal.fire({
            title: 'Είστε σίγουροι?',
            text: "Αν διαγράψετε τον χώρο δεν υπάρχει γυρισμός!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Διαγραφή',
            cancelButtonText: 'Άκυρο'
        }).then((result) => {
            if (result.value) {
                this.siteEntityService.deleteFromBackend(this.site.id)
                    .subscribe(() => {
                        this.deleteSiteLocal();
                        Swal.fire(
                            'Διεγράφηκε ο χώρος!',
                            'Έγινε πλήρης διαγραφή του αρχαιολογικού χώρου',
                            'success'
                        )
                    })
            }
        })
    }

    createHotSpot() {
        let newHotSpot = new HotSpot(this.languages);
        this.selectedPanorama.panoramaHotSpots.push(newHotSpot);
        this.selectedMonument = newHotSpot;
        this.selectedPanorama.panoramaHotSpots = [...this.selectedPanorama.panoramaHotSpots];
    }

    groupByFn = (item) => item.hotSpotType === 'NAVIGATION' ? item.panoramaComponent : item.hotSpotType;

    openPanoramicEditModal(newPanoramic: boolean) {
        let modalRef = this.modalService.open(this.modalPanoramicRef, {centered: true, size: 'lg'});
        this.modalParams.edit = newPanoramic;
        modalRef.result.then((data) => {
        }, (reason) => {
            this.modalParams = {edit: false, blob: "", base64: ""};
        });
    }

    onSelectPanoramic(event) {
        const fileURL = URL.createObjectURL(event.addedFiles[0]);
        var reader = new FileReader();
        reader.readAsDataURL(event.addedFiles[0]);
        reader.onload = () => {
            this.modalParams.base64 = reader.result + '';
            this.modalParams.blob = fileURL;
        };

    }

    newPanorama() {
        let panoramaImage = new PanoramaImages();
        panoramaImage.image = this.modalParams.blob;
        panoramaImage.base64 = this.modalParams.base64;
        panoramaImage.siteId = this.site.id;
        this.site.panoramaImages.push(panoramaImage);
        this.site.panoramaImages = this.mutateWithNamePanoramaImages(this.site.panoramaImages);
        this.selectedPanorama = this.site.panoramaImages[this.site.panoramaImages.length - 1];
        this.selectedPanoramaChanged.emit(this.selectedPanorama);
        this.modalParams = {edit: false, blob: "", base64: ""};
        this.modalService.dismissAll();
    }

    mobileToggling($event) {
        if ($event.target.checked) {
            this.site.panoramaImages.forEach((panoramaImage) => {
                if (panoramaImage.id !== this.selectedPanorama.id) {
                    panoramaImage.mobile = false;
                } else {
                    panoramaImage.mobile = $event.target.checked;
                }
            })
        }
    }

    updatePanoramaMetaData($event) {
        if ($event.camera[0] != null) {
            this.selectedPanorama.rotateX = $event.camera[0];
            this.selectedPanorama.rotateY = $event.camera[1];
            Swal.fire(
                'Ενημερώθηκε η θέση!',
                'Ενημερώθηκε η αρχική θέση της πανοραμικής και της πυξίδας. ΠΡΟΣΟΧΗ!! Για να γίνει μόνιμη αυτή η αλλαγή θα πρέπει να αποθηκευτεί ο' +
                ' χώρος.',
                'success'
            )
        }
        this.selectedPanorama.northRotateY = $event.northView;
    }

    deletePanoramic() {
        if (this.selectedPanorama) {
            const searchIndex = this.site.panoramaImages.findIndex((el) => el.id === this.selectedPanorama.id);
            this.selectedPanorama = null;
            this.site.panoramaImages[searchIndex].forDeletion = true;
            this.site.panoramaImages = this.mutateWithNamePanoramaImages(this.site.panoramaImages);
            this.selectedPanoramaChanged.emit(this.selectedPanorama);
        }
    }

    private updateMarker(site) {
        const newLatLng = new L.LatLng(site.latitude, site.longitude);
        this.marker.setLatLng(newLatLng);
        this.map.flyTo(newLatLng)
    }

    private deleteSiteLocal() {
        let sites = this.screenService.sites.getValue();
        let siteIndex = sites.findIndex((el) => el.id === this.site.id);
        if (siteIndex > -1) {
            sites.splice(siteIndex, 1);
            this.screenService.sites.next(sites);
        }
    }

    private mutateWithNamePanoramaImages(panoramaImages: []) {
        return panoramaImages
            .filter((el: any) => !el.forDeletion)
            .map((el: any) => {
                el.name = "Πανοραμική " + el.id;
                return el;
            });
    }
}
